import { Box, Paper, Chip } from '@material-ui/core';
import React, { useState } from 'react';
import FileInputButton from '../../../atoms/fileInputButton';
import Typography from '../../../atoms/typography';
import ButtonComponent from '../../../atoms/button';
import commons from '../../../../assets/styles/commons';
import { useImportFile } from '../../../../hooks/freights/useImportFile';
import { useFormContext } from 'react-hook-form';
import { useHistory, useLocation } from 'react-router-dom';
import colors from '../../../../assets/styles/colors';
import InputBase from '@mui/material/InputBase';
import { Close as CloseIcon } from '@material-ui/icons';

interface Props {
  onNextStep: () => void;
  onFilesChange: (files: string[]) => void;
}

const IncludeDeliveries: React.FC<Props> = ({ onNextStep, onFilesChange }) => {
  const history = useHistory();
  const location = useLocation();
  const { setValue } = useFormContext();
  const [startedImporting, setStartedImporting] = useState(false);
  const { execute: executeImport } = useImportFile();
  const [hasImported, setHasImported] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);

  const handleImportFile = async (files: FileList | null) => {
    if (files && files.length > 0) {
      const newFiles = Array.from(files);
      const updatedFiles = [...selectedFiles, ...newFiles];
      setSelectedFiles(updatedFiles);

      const fileNames = updatedFiles.map(file => file.name);
      onFilesChange(fileNames);
    }
  };

  const handleRemoveFile = (index: number) => {
    const updatedFiles = selectedFiles.filter((_, i) => i !== index);
    setSelectedFiles(updatedFiles);

    const fileNames = updatedFiles.map(file => file.name);
    onFilesChange(fileNames);

    if (updatedFiles.length === 0) {
      setHasImported(false);
    }
  };

  const handleProcessFiles = async () => {
    if (selectedFiles.length > 0) {
      const formData = new FormData();
      setStartedImporting(true);

      for (let i = 0; i < selectedFiles.length; i++) {
        formData.append('freights', selectedFiles[i]);
      }

      const importFreight = await executeImport(formData, () => {
        setHasImported(true);
        setStartedImporting(false);
      });

      setValue('freightRequestId', importFreight?.freightRequestId);
      setValue('totalDeliveries', importFreight?.totalDeliveries);
      setValue('totalWeight', importFreight?.totalWeight);

      if (importFreight?.freightRequestId) {
        const search = new URLSearchParams(location.search);
        search.set('freightRequestId', importFreight.freightRequestId);
        history.replace(`${location.pathname}?${search.toString()}`);
      }
    }
  };

  const handleNext = () => {
    onNextStep();
  };

  return (
    <Box component={'div'}>
      <Paper
        component="form"
        elevation={0}
        style={{
          display: 'flex',
          alignItems: 'center',
          minHeight: '40px',
          border: '1px solid #FF7206',
          backgroundColor: colors.secondary.softBlue,
          padding: '8px',
        }}
      >
        <InputBase
          sx={{ ml: 1, flex: 1, fontFamily: commons.fontFamily }}
          placeholder="Anexe os fretes aqui...."
          type="text"
          readOnly
        />

        <FileInputButton
          label="Selecionar Arquivos"
          loading={startedImporting}
          onChange={handleImportFile}
          multiple={true}
          acceptedFileTypes=".csv,.txt,.doc"
        />
      </Paper>

      {selectedFiles.length > 0 && (
        <Box mt={2}>
          <Typography color="textSecondary" style={{ marginBottom: 8 }}>
            Arquivos selecionados ({selectedFiles.length}):
          </Typography>
          <Box display="flex" flexWrap="wrap">
            {selectedFiles.map((file, index) => (
              <Box key={index} style={{ margin: '4px' }}>
                <Chip
                  label={file.name}
                  onDelete={() => handleRemoveFile(index)}
                  deleteIcon={<CloseIcon />}
                  variant="outlined"
                  color="primary"
                  size="small"
                  style={{
                    height: 28,
                    padding: '0 12px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                />
              </Box>
            ))}
          </Box>
        </Box>
      )}

      <Typography mt={2} color="gray">
        Arquivos permitidos: .csv, .txt, .doc
      </Typography>

      {selectedFiles.length > 0 && !hasImported && (
        <ButtonComponent
          theme="primary"
          justifyContent="flex-start"
          mt={3}
          onClick={handleProcessFiles}
          loading={startedImporting}
          style={{ width: 200 }}
        >
          {startedImporting ? 'Processando...' : 'Processar Arquivos'}
        </ButtonComponent>
      )}

      <ButtonComponent
        theme="primary"
        justifyContent="flex-end"
        mt={5}
        onClick={handleNext}
        disabled={!hasImported}
        style={{ width: 140 }}
      >
        Próximo
      </ButtonComponent>
    </Box>
  );
};

export default IncludeDeliveries;